import { Component, type ReactNode } from 'react';

/** Vangt onverwachte fouten op zodat de gebruiker een nette melding ziet in plaats van een wit scherm. */
export class Foutgrens extends Component<{ children: ReactNode }, { fout: Error | null }> {
  state = { fout: null as Error | null };
  static getDerivedStateFromError(fout: Error) {
    return { fout };
  }
  render() {
    if (!this.state.fout) return this.props.children;
    return (
      <div className="midden">
        <div className="paneel login">
          <h2>Er ging iets mis</h2>
          <p className="mute">{this.state.fout.message}</p>
          <button className="knop primair" onClick={() => { this.setState({ fout: null }); window.location.href = '/'; }}>
            Opnieuw laden
          </button>
        </div>
      </div>
    );
  }
}
